<!-- eslint-disable vue/no-v-html -->
<template>
  <BModal
    :id="modal.id"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
    hide-header
    :centered="true"
  >
    <div
      class="position-absolute"
      style="right: 15px; top: 15px;"
    >
      <feather-icon
        icon="XIcon"
        class="cursor-pointer w-[20px] h-[20px]"
        @click="handleClose"
      />
    </div>
    <div class="text-center my-1">
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
        alt="Komerce"
        class="m-auto w-[100px]"
      >
      <div class="font-semibold text-2xl text-black my-2">
        {{ modal.title }}
      </div>
      <div v-html="modal.description" />
      <div class="flex items-between gap-[1rem]">
        <BButton
          size="md"
          variant="outline-primary"
          block
          @click="modal.negativeButtonAction"
        >
          {{ modal.negativeButtonText }}
        </BButton>
        <BButton
          size="md"
          variant="primary"
          block
          class="m-0"
          @click.prevent="modal.positiveButtonAction"
        >
          {{ modal.positiveButtonText }}
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'ModalConfirmation',
  props: {
    modal: {
      type: Object,
      default: () => ({
        id: 'modal-confirmation',
        title: 'Judul Modal',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati unde id, maxime soluta est rem?',
        negativeButtonAction: () => {},
        negativeButtonText: 'Tidak',
        positiveButtonAction: () => {},
        positiveButtonText: 'Iya',
        closeButtonAction: () => {},
      }),
    },
  },
  methods: {
    handleClose() {
      this.$bvModal.hide(this.modal.id)
      this.modal.closeButtonAction()
    },
  },
}
</script>
